module.exports = __webpack_public_path__ + "static/media/icon-character__hannah-arendt.c194aec2.svg";